import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Button from '@fff-web/fff-ui-shared/Button';

import { getTrackingUrl } from 'pages/MyAccount/utils/orders';
import styles from './styles.module.scss';

const ShipmentHeader = ({
  title,
  subtitle,
  shipmentDetails,
  trackShipment,
}) => {
  const trackingUrl = shipmentDetails && getTrackingUrl(shipmentDetails.carrier, shipmentDetails.trackingNumber);
  const showUnavailableButton = title === 'Drop Ship';

  const handleClickTrackShipment = () => {
    trackShipment(shipmentDetails.trackingNumber, 'Shipment Tracked');
    window.open(trackingUrl, '_blank');
  };

  return (
    <div className={styles.header}>
      <div>
        <h2>{title}</h2>
        <h3>{subtitle}</h3>
      </div>
      {trackingUrl && (
        <div className={styles['button-container']}>
          <Button
            variation="black"
            containerFullWidth
            onClick={handleClickTrackShipment}
          >
            Track Shipment
          </Button>
        </div>
      )}
      {showUnavailableButton && (
        <>
          <div className={styles.dropship}>
            <div
              className={styles.unavailable}
              data-tip="This product will ship directly from the retailer and separately from the rest of your order."
              data-for="unavailable"
            >
              <Button
                variation="black"
                containerFullWidth
                disabled
              >
                Tracking Link Unavailable
              </Button>
            </div>
            <p>
              <a
                href="https://support.fabfitfun.com/?a=What-is-a-Drop-Ship-item---id--GsqzZqVjRNuzc27MiwdOLQ "
                target="_blank"
                rel="noreferrer"
              >
                Click here
              </a>
              {' '}
              for more information.
            </p>
          </div>
          <ReactTooltip
            id="unavailable"
            type="dark"
            effect="solid"
            className={styles.tooltip}
          />
        </>
      )}
    </div>
  );
};

ShipmentHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  shipmentDetails: PropTypes.shape({
    carrier: PropTypes.string,
    trackingNumber: PropTypes.string,
  }),
  trackShipment: PropTypes.func.isRequired,
};

ShipmentHeader.defaultProps = {
  title: null,
  shipmentDetails: null,
};

export default ShipmentHeader;
